import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {  Observable, Subject } from 'rxjs';
import { ConfirmationDialogService } from 'src/app/modules/confirmation-dialog/confirmation-dialog.service';
import { SettingsComponent } from '../settings/settings.component';

@Injectable({
  providedIn: 'root',
})
export class SettingsDialogService implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private dialogRef: MatDialogRef<any>;
  private _isDirty = false;

  constructor(
    private readonly confirmService: ConfirmationDialogService,
    private readonly dialogService: MatDialog
  ) {}

    ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  public close(): void {
    this.dialogRef?.close();
    this.dialogRef = null;
    document.body.classList.remove('cdk-global-scrollblock');
  }

  public hide() {
    if (this.dialogRef) {
      this.dialogRef.addPanelClass('hidden-dialog'); // Add a CSS class to hide the dialog
      document.body.classList.remove('cdk-global-scrollblock'); // Remove the scroll block class
      // hide the backdrop 
      const backdrop = document.querySelector('.cdk-overlay-backdrop');
      if (backdrop) {
        backdrop.classList.add('hidden-backdrop');
      }
    }
  }

  private show() {
    if (this.dialogRef) {
      this.dialogRef.removePanelClass('hidden-dialog'); // Remove the CSS class to show the dialog 
      document.body.classList.add('cdk-global-scrollblock'); // Reapply the scroll block class

      // show the backdrop 
      const backdrop = document.querySelector('.cdk-overlay-backdrop');
      if (backdrop) {
        backdrop.classList.remove('hidden-backdrop');
      }
    }
  }

  public confirmBeforeNextAction(): Observable<boolean> {
      return this.confirmService.showModelIsDirtyDialog();
  }

  public openOrShowDialog() {
    if (this.dialogRef) {
      this.show();
      return;
    }
    this.open();
  }

  private open() {
    document.body.classList.add('cdk-global-scrollblock');
    this.setDialogRef(
      this.dialogService.open(SettingsComponent, {
        panelClass: 'settings-dialog',
        //matches the titleId SettingsComponent passes to app-dialog-header
        ariaLabelledBy: 'profile-settings-title',
        disableClose: true,
        maxWidth: '80vw',
        minWidth: '80vw',
      })
    );
  }

  private setDialogRef(ref: MatDialogRef<any>) {
    this.dialogRef = ref;

    // close() above is not the only way this dialog goes away - MatDialog.closeAll() on logout
    // closes it too. This service is providedIn: 'root', so it outlives the logout navigation, and
    // a cached ref to a disposed overlay makes the next openOrShowDialog() take the show() branch
    // and silently open nothing. Clear it however the dialog was closed. The identity check keeps a
    // late afterClosed from a previous dialog from clobbering a newer one.
    ref.afterClosed().subscribe(() => {
      if (this.dialogRef === ref) {
        this.dialogRef = null;
        document.body.classList.remove('cdk-global-scrollblock');
      }
    });
  }

}
